import { Button } from '../../buttons/Button'

type FormSectionActionsProps = {
  isDirty: boolean
  isValid?: boolean
  loading?: boolean
  disableResetWhileLoading?: boolean
  showReset?: boolean
  disableReset?: boolean
  enableSecondaryActionWhenUnchanged?: boolean
  onSave: () => void
  onCancel: () => void
  saveLabel: string
  resetLabel: string
}

const FormSectionActions = ({
  isDirty,
  isValid = true,
  loading = false,
  disableResetWhileLoading = true,
  showReset = true,
  disableReset = false,
  enableSecondaryActionWhenUnchanged = false,
  onSave,
  onCancel,
  saveLabel,
  resetLabel,
}: FormSectionActionsProps) => (
  <>
    {showReset && (
      <Button
        label={resetLabel}
        variant="ghost"
        size="sm"
        block
        onClick={onCancel}
        disabled={
          disableReset ||
          (!isDirty && !enableSecondaryActionWhenUnchanged) ||
          (loading && disableResetWhileLoading)
        }
      />
    )}

    <Button
      label={saveLabel}
      variant="primary"
      size="sm"
      block
      onClick={onSave}
      disabled={!isDirty || !isValid}
      loading={loading}
    />
  </>
)

export default FormSectionActions
